import React from 'react';

import { ENV } from '@environment';
import GoogleMapReact from 'google-map-react';

import Shimmer from 'components/Shimmer';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { HotelsResultResponse } from 'models/hotelsSearch';

import { Container, Button, Icon } from './styles';

const DEFAULT_ZOOM_VALUE = 14;
const GOOGLE_MAPS_API_KEY = ENV.API_KEYS.GOOGLE_MAPS_API_KEY as string;

interface Props {
  text: string;
  onClick: () => void;
  isLoading: boolean;
  results?: HotelsResultResponse[];
}

export const SmallMapLoader = () => (
  <Container>
    <Shimmer width="270px" height="160px"></Shimmer>
  </Container>
);

const SmallMap = ({ text, onClick, isLoading, results }: Props) => {
  const { t } = useStoreTranslation();
  const lat = results && results[0] ? results[0].latitude : 0;
  const lng = results && results[0] ? results[0].longitude : 0;

  if (isLoading) return <SmallMapLoader />;
  if (!results || results.length === 0) return null;

  return (
    <Container onClick={onClick}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: GOOGLE_MAPS_API_KEY,
          language: t('locale').substring(0, 2),
          region: t('locale').substring(3),
          libraries: ['places'],
        }}
        defaultCenter={{ lat, lng }}
        defaultZoom={DEFAULT_ZOOM_VALUE}
        yesIWantToUseGoogleMapApiInternals={true}
        options={{
          fullscreenControl: false,
          zoomControl: false,
        }}
      ></GoogleMapReact>
      <Button>
        <Icon />
        {text}
      </Button>
    </Container>
  );
};
export default SmallMap;
